// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__12geE","range":"MonthRangeSwitch_range__14sWT","disabled":"MonthRangeSwitch_disabled__1erLB"};